import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

export enum SyncOverlayScreen {
    none = 0,
    progress = 1,

}

export class SyncOverlayState {

    screen: SyncOverlayScreen;
    time: number;
}

@Injectable()
export class SyncOverlayService {
    private collapsedStateSource = new Subject<SyncOverlayState>();
    public SyncScreenRequest$ = this.collapsedStateSource.asObservable();


    public ShowProgressOverlay(time: number = 0) {
        const screen = new SyncOverlayState();
        screen.screen = SyncOverlayScreen.progress;
        screen.time = time;
        this.collapsedStateSource.next(screen);
    }

    public HideOverlay() {

        setTimeout(() => {
            const screen = new SyncOverlayState();
            screen.screen = SyncOverlayScreen.none;
            this.collapsedStateSource.next(screen);
        }, 500);
    }

}
